var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect } from 'react';
import { EVENT_TYPE } from 'shared/utils/mixpanel';
import { useTrackEvent } from './useTrackEvent';
export var useComponentView = function (spring_doc_id, eventName, component_name, eventProperties) {
    if (eventName === void 0) { eventName = 'View Component'; }
    var trackEvent = useTrackEvent();
    if (component_name) {
        useEffect(function () {
            trackEvent(EVENT_TYPE.COMPONENT_VIEWED, component_name, eventName, __assign({ spring_doc_id: spring_doc_id }, eventProperties));
        }, []);
    }
    else {
        var comp_1 = location.pathname;
        var compArr = comp_1.split('/');
        if (process.env.REACT_APP_LOCAL_CG_ENV) {
            // ['', 'client', '4643ed27-ec5f-4a3c-a3aa-3f39a79d032d', 'assessments']
            compArr[2] = '[:id]';
        }
        else {
            // ['admin', 'compass', 'client', 'a6ac7f54-1179-4e49-a7df-40e316fe759f', 'assessments']
            compArr[4] = '[:id]';
        }
        comp_1 = compArr.join('/');
        useEffect(function () {
            trackEvent(EVENT_TYPE.COMPONENT_VIEWED, comp_1, eventName, __assign({ spring_doc_id: spring_doc_id }, eventProperties));
        }, []);
    }
};
export var useTriggeredComponentView = function (spring_doc_id, eventName, component_name, eventProperties) {
    if (eventName === void 0) { eventName = 'View Component'; }
    var trackEvent = useTrackEvent();
    if (component_name) {
        return function () {
            return trackEvent(EVENT_TYPE.COMPONENT_VIEWED, component_name, eventName, __assign({ spring_doc_id: spring_doc_id }, eventProperties));
        };
    }
    else {
        var comp_2 = location.pathname;
        var compArr = comp_2.split('/');
        if (process.env.REACT_APP_LOCAL_CG_ENV) {
            // ['', 'client', '4643ed27-ec5f-4a3c-a3aa-3f39a79d032d', 'assessments']
            compArr[2] = '[:id]';
        }
        else {
            // ['admin', 'compass', 'client', 'a6ac7f54-1179-4e49-a7df-40e316fe759f', 'assessments']
            compArr[4] = '[:id]';
        }
        comp_2 = compArr.join('/');
        return function () {
            return trackEvent(EVENT_TYPE.COMPONENT_VIEWED, comp_2, eventName, __assign({ spring_doc_id: spring_doc_id }, eventProperties));
        };
    }
};
